export const scrollToElementWithFocus = (
  element: HTMLElement,
  options: {
    offset?: number;
    highlightDuration?: number;
    scale?: number;
    glowColor?: string;
    glowOpacity?: number;
  } = {}
) => {
  const {
    highlightDuration = 300,
    scale = 1.05,
    glowColor = "rgba(251, 196, 78, 0.5)",
  } = options;

  element.scrollIntoView({
    behavior: "smooth",
    block: "center",
  });

  setTimeout(() => {
    element.focus();

    element.style.transition = "all 0.3s ease";
    element.style.transform = `scale(${scale})`;
    element.style.boxShadow = `0 0 20px ${glowColor}`;

    setTimeout(() => {
      element.style.transform = "scale(1)";
      element.style.boxShadow = "";
    }, highlightDuration);
  }, 800);
};

export const scrollToElementBySelector = (
  selector: string,
  options: {
    offset?: number;
    highlightDuration?: number;
    scale?: number;
    glowColor?: string;
    glowOpacity?: number;
  } = {}
) => {
  const element = document.querySelector(selector) as HTMLElement | null;

  if (element) {
    scrollToElementWithFocus(element, options);
  } else {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
};
